const data = {
  newTaskModal: {
    show: false,
    title: ''
  },
  teamsChatModal: {
    show: false,
    isTeams: false,
  },
  newProjectModal: {
    show: false,
    team: ''
  },
  customFieldsModal: {
    show: false,
    data: {}
  },
  workspaceFieldsModal: {
    show: false,
    selectedProject: '',
    allowedProjectIds: null,
  },
  duplicateProjectModal: {
    show: false,
    selectedProject: ''
  },
  workspaceTagsModal: {
    show: false,
  },
  inviteToProjectModal: {
    show: false,
    selectedProject: '',
  },
  inviteToWorkspaceModal: {
    show: false,
  },
  editProjectDetailsModal: {
    show: false,
    selectedProject: '',
  },
  portfolioModal: {
    show: false,
    projectId: false,
    portfolioId: false,
  },
  projectInvitesBanner: {
    projectId: false,
    members: [],
  },
  editCustomFieldModal: {
    show: false,
    selectedCustomField: '',
    selectedProject: ''
  },
  duplicateTaskModal: {
    show: false,
    selectedTask: ''
  },
  customChartModal: {
    show: false,
    dashboardId: undefined,
    dashboardTitle: undefined,
    isUpdate: false
  },
  chartFullScreenModal: {
    show: false,
    dashboardId: undefined,
    reportId: undefined,
  }
};

const modalReducer = (state = data, action) => {
  switch (action.type) {
    case "toggle-new-task-modal":
      return {
        ...state,
        newTaskModal: {
          show: action.payload.value,
          title: action.payload?.title || '',
          assignee: action.payload?.assignee || null,
        },
      };
    case "toggle-new-project-modal":
      return {
        ...state,
        newProjectModal: {
          show: action.payload.value,
          team: action.payload?.team
        },
        newTaskModal: {
          show: false,
        },
      };
    case "toggle-new-teams-chats-modal":
      return {
        ...state,
        teamsChatModal: {
          show: action.payload.value,
          isTeams: action.payload?.isTeams || false,
        },
      };
    case "toggle-workspace-fields-modal":
      return {
        ...state,
        workspaceFieldsModal: {
          show: action.payload?.value,
          selectedProject: action.payload?.projectId,
          allowedProjectIds: action.payload?.allowedProjectIds || null,
        },
      };
    case "toggle-duplicate-project-modal":
      return {
        ...state,
        duplicateProjectModal: {
          show: action.payload?.value,
          selectedProject: action.payload?.project,
        },
      };
    case "toggle-workspace-tags-modal":
      return {
        ...state,
        workspaceTagsModal: {
          show: action.payload?.value,
        }
      };
    case "toggle-invite-to-project-modal":
      return {
        ...state,
        inviteToProjectModal: {
          show: action.payload?.value,
          selectedProject: action.payload?.projectId || '',
        },
      };
    case "toggle-edit-project-details-modal":
      return {
        ...state,
        editProjectDetailsModal: {
          show: action.payload?.value,
          selectedProject: action.payload?.project,
        },
      };
    case "toggle-invite-to-workspace-modal":
      return {
        ...state,
        inviteToWorkspaceModal: {
          show: action.payload?.value,
        }
      };
    case "toggle-portfolio-modal":
      return {
        ...state,
        portfolioModal: {
          show: action.payload?.value,
          portfolioId: action.payload?.portfolioId || false,
          projectId: action.payload?.projectId || false,
        }
      };

    case "toggle-project-invites-banner":
      return {
        ...state,
        projectInvitesBanner: {
          projectId: action.payload?.projectId || false,
          members: action.payload?.members || [],
        }
      };
    case "toggle-edit-customfield-modal":
      return {
        ...state,
        editCustomFieldModal: {
          show: action.payload?.value,
          selectedCustomField: action.payload?.customField,
          selectedProject: action?.payload?.project
        },
      };

    case "toggle-duplicate-task-modal":
      return {
        ...state,
        duplicateTaskModal: {
          show: action.payload?.value,
          selectedTask: action?.payload?.task
        },
      };

    case "toggle-custom-horizontal-chart-modal":
      return {
        ...state,
        customChartModal: {
          show: action.payload?.show,
          dashboardId: action.payload?.dashboardId,
          dashboardTitle: action.payload?.dashboardTitle,
          reportId: action.payload?.reportId
        },
      };

    case "toggle-chart-fullscreen-modal":
      return {
        ...state,
        chartFullScreenModal: {
          show: action.payload?.value,
          dashboardId: action.payload?.dashboardId,
          reportId: action.payload?.reportId,
        },
      };

    case 'reset-drawer': {
      return {
        ...data
      }
    }

    default:
      return state;
  }
};
export default modalReducer;
